module.exports = __webpack_public_path__ + "static/img/30001 (4).c7ca54b.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30001 (4).webp
// module id = zN3Q
// module chunks = 14